/**************************************************
 * Nombre:       Portada_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Caracteristicas_Home from "../../Tarjetas/Tarjeta_Caracteristicas_Home";

import check_caracteristicas_home from "../../../Recursos/icono_check_caracteristicas_home.png"
import user_caracteristicas_home from "../../../Recursos/icono_user__caracteristicas_home.png"
import hot_sale_caracteristicas_home from "../../../Recursos/icono_hot_sale_caracteristicas_home.png"
import earth_caracteristicas_home from "../../../Recursos/icono_earth_caracteristicas_home.png"
import idea_caracteristicas_home from "../../../Recursos/icono_idea_caracteristicas_home.png"

const tarjetas = [
    {
        icono: check_caracteristicas_home,
        titulo: "Productos confiables y rentables",
        descripcion: "Garantizamos calidad en cada entrega, con alimentos fáciles de preparar que optimizan tiempo y costos para nuestros clientes."
    },
    {
        icono: user_caracteristicas_home,
        titulo: "Atencion Personalizada",
        descripcion: "Como especialistas en food service, brindamos una experiencia adaptada a las demandas específicas de cada negocio, asegurando el máximo rendimiento en sus operaciones."
    },
    {
        icono: hot_sale_caracteristicas_home,
        titulo: "Precios Justos",
        descripcion: "Competimos con precios equitativos, eliminando intermediarios innecesarios para ofrecer productos directamente desde la fábrica, lo que se traduce en valor para nuestros clientes."
    },
    {
        icono: earth_caracteristicas_home,
        titulo: "Cobertura Regional",
        descripcion: "Con tiendas estratégicamente ubicadas y rutas foráneas que alcanzan pueblos, llevamos nuestras soluciones a donde se necesiten."
    },
    {
        icono: idea_caracteristicas_home,
        titulo: "Innovacion en el mercado",
        descripcion: "Desde 2015, lideramos la introducción de productos congelados en la región, transformando la manera en que nuestros clientes trabajan y maximizan sus ingresos."
    }
];

const Caracteristicas_Home = () => {
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            paddingTop={4}
        >
            <Grid
                container
                justifyContent={"center"}
                alignItems={'flex-start'}
                size={12}
                direction="row"
                spacing={2}
                sx={{
                    px: 2,
                    maxWidth: "1400px",
                    color: "white",
                }}
            >
                {tarjetas.map((tarjeta, index) => (
                    <Grid
                        size={{xs: 12, sm: 6, md: 6}}
                        sx={{paddingTop: 12}}
                    >
                        <Tarjeta_Caracteristicas_Home
                            key={index}
                            icono={tarjeta.icono}
                            titulo={tarjeta.titulo}
                            descripcion={tarjeta.descripcion}/>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}
export default Caracteristicas_Home

